import React, { useState, useEffect } from "react";
import {
    Box,
    Paper,
    Typography,
    TextField,
    Button,
    IconButton,
    InputAdornment,
    Alert,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
    const [user, setUser] = useState("");
    const [pass, setPass] = useState("");
    const [error, setError] = useState("");
    const [showPass, setShowPass] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const now = Date.now();
        try {
            const response = await fetch("https://api.datasenseai-neuronize.charlizeonline.net/api/auth/login", {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username: user, password: pass }),
            });

            if (!response.ok) {
                setError("Credenciales inválidas");
                return;
            }

            const data = await response.json();
            const now = Date.now();

            sessionStorage.setItem("username", data.nombre);
            sessionStorage.setItem("loginTime", now.toString());
            sessionStorage.setItem("lastActivity", now.toString());
            sessionStorage.setItem("expiresIn", data.expires_in_minutes);
            navigate("/inicio");
        } catch (err) {
            setError("Credenciales inválidas");
        }
    };

    useEffect(() => {
        if (error) {
            const timer = setTimeout(() => {
                setError("");
            }, 5000);
            return () => clearTimeout(timer);
        }
    }, [error]);

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "#f4f6f8",
                p: { xs: 1, sm: 2 },
            }}
        >
            <Paper
                elevation={6}
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    p: { xs: 2, sm: 4 },
                    borderRadius: 4,
                    maxWidth: 380,
                    width: { xs: "100%", sm: 380 },
                    textAlign: "center",
                }}
            >
                <Box sx={{ mb: 2 }}>
                    <img
                        src="/images/logo_login.png"
                        alt="Logo"
                        style={{ width: "200px", height: "80px" }}
                    />
                </Box>

                <Typography
                    variant="h5"
                    sx={{ color: "#01579B", fontWeight: 700, mb: 2 }}
                >
                    Login
                </Typography>

                <form onSubmit={handleSubmit} style={{ width: "100%" }}>
                    <TextField
                        label="Username"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        value={user}
                        onChange={(e) => setUser(e.target.value)}
                    />

                    <TextField
                        label="Password"
                        variant="outlined"
                        type={showPass ? "text" : "password"}
                        fullWidth
                        margin="normal"
                        value={pass}
                        onChange={(e) => setPass(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPass(!showPass)} edge="end">
                                        {showPass ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}
                    />

                    {error && (
                        <Alert severity="error" sx={{ mt: 1 }}>
                            {error}
                        </Alert>
                    )}

                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{
                            mt: 3,
                            background: "#01579B",
                            "&:hover": { background: "#013a63" },
                        }}
                    >
                        Sign In
                    </Button>
                </form>
            </Paper>
        </Box>
    );
};

export default LoginPage;
